import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    token: '',
    user: 0,
    name: '',
    userType: '',
    role: '',
    menu: {},
    permissions: [],
    // `notify` ya no vive aquí: la campana de avisos es efímera y este slice se
    // persiste. Ver `realtimeSlice`.
  },
  reducers: {
    setToken: (state, { payload }) => {
      state.token = payload;
    },
    setMenu: (state, { payload }) => {
      state.menu = payload;
    },
    setCurrentUser: (state, { payload }) => {
      state.user = payload;
    },
    setName: (state, { payload }) => {
      state.name = payload;
    },
    setUserType: (state, { payload }) => {
      state.userType = payload;
    },
    setRole: (state, { payload }) => {
      state.role = payload;
    },
    setPermission: (state, { payload }) => {
      state.permissions = payload;
    },
    logout: (state) => {
      state = this.initialState;
    },
  },
});
export const {
  setToken,
  setMenu,
  logout,
  setNotify,
  setCurrentUser,
  setName,
  setUserType,
  setRole,
  setPermission,
} = userSlice.actions;
export default userSlice.reducer;
